import symptomCheckerReports from 'translations/specific/symptomCheckerReports.mjs';

export const triageLevelNamesTranslationArrays = Object.values(symptomCheckerReports.triageLevelsDescriptions).map(triage => triage.header);
